import React, { useState } from "react";
import { FaRegCopy } from "react-icons/fa";

export const ThanksScreen = (props) => {
  const coupons = [
    { id: 1, value: "13313ADK494K", reward: "₹50" },
    { id: 2, value: "98765XYZ1234", reward: "₹150" },
  ];

  const [copied, setCopied] = useState({});

  const copyToClipboard = (id, couponValue) => {
    navigator.clipboard.writeText(couponValue);
    setCopied((prev) => ({ ...prev, [id]: true }));
    setTimeout(() => {
      setCopied((prev) => ({ ...prev, [id]: false }));
    }, 2000);
  };

  return (
    <div className="quiz-container">
      <div className="winner-container centerElement">
        <div className="winner-header">
          <div className="winner-icon">
            <img src="/Images/happy-face.png" alt="Happy Face" />
          </div>
          <h2 className="question-title">Thanks for participating!</h2>
          <p>
            We appreciate your participation in our contest!
            {/* Result will be announced 18 Feb 2025 12:00PM */}
          </p>
        </div>
        {/* <div className="coupon-section">
        <h3>Congratulations!</h3>
        {coupons.map((coupon) => (
          <div className="coupon-item" key={coupon.id}>
            <div className="coupon-info">
              <p>Who do you predict will win the match?</p>
              <span>
                Get <b>{coupon.reward}</b> Coupon for this
              </span>
            </div>
            <div>
              <div className="coupon-code">
                <span>{coupon.value}</span>
                <FaRegCopy
                  className="copy-icon"
                  onClick={() => copyToClipboard(coupon.id, coupon.value)}
                />
              </div>
              {copied[coupon.id] && (
                <span className="copied-text">Copied!</span>
              )}
            </div>
          </div>
        ))}
      </div> */}
      </div>
    </div>
  );
};
